/**
 * Lista completa de países com códigos DDI e bandeiras.
 * Compartilhado entre admin, guia e cliente.
 */

export interface CountryDDI {
  code: string;
  name: string;
  flag: string;
  ddi: string;
}

export const countriesDDI: CountryDDI[] = [
  { code: 'BR', name: 'Brasil', flag: '🇧🇷', ddi: '+55' },
  { code: 'AF', name: 'Afeganistão', flag: '🇦🇫', ddi: '+93' },
  { code: 'ZA', name: 'África do Sul', flag: '🇿🇦', ddi: '+27' },
  { code: 'AL', name: 'Albânia', flag: '🇦🇱', ddi: '+355' },
  { code: 'DE', name: 'Alemanha', flag: '🇩🇪', ddi: '+49' },
  { code: 'AD', name: 'Andorra', flag: '🇦🇩', ddi: '+376' },
  { code: 'AO', name: 'Angola', flag: '🇦🇴', ddi: '+244' },
  { code: 'AG', name: 'Antígua e Barbuda', flag: '🇦🇬', ddi: '+1268' },
  { code: 'SA', name: 'Arábia Saudita', flag: '🇸🇦', ddi: '+966' },
  { code: 'DZ', name: 'Argélia', flag: '🇩🇿', ddi: '+213' },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷', ddi: '+54' },
  { code: 'AM', name: 'Armênia', flag: '🇦🇲', ddi: '+374' },
  { code: 'AU', name: 'Austrália', flag: '🇦🇺', ddi: '+61' },
  { code: 'AT', name: 'Áustria', flag: '🇦🇹', ddi: '+43' },
  { code: 'AZ', name: 'Azerbaijão', flag: '🇦🇿', ddi: '+994' },
  { code: 'BS', name: 'Bahamas', flag: '🇧🇸', ddi: '+1242' },
  { code: 'BD', name: 'Bangladesh', flag: '🇧🇩', ddi: '+880' },
  { code: 'BB', name: 'Barbados', flag: '🇧🇧', ddi: '+1246' },
  { code: 'BH', name: 'Bahrein', flag: '🇧🇭', ddi: '+973' },
  { code: 'BE', name: 'Bélgica', flag: '🇧🇪', ddi: '+32' },
  { code: 'BZ', name: 'Belize', flag: '🇧🇿', ddi: '+501' },
  { code: 'BJ', name: 'Benim', flag: '🇧🇯', ddi: '+229' },
  { code: 'BY', name: 'Bielorrússia', flag: '🇧🇾', ddi: '+375' },
  { code: 'BO', name: 'Bolívia', flag: '🇧🇴', ddi: '+591' },
  { code: 'BA', name: 'Bósnia e Herzegovina', flag: '🇧🇦', ddi: '+387' },
  { code: 'BW', name: 'Botsuana', flag: '🇧🇼', ddi: '+267' },
  { code: 'BN', name: 'Brunei', flag: '🇧🇳', ddi: '+673' },
  { code: 'BG', name: 'Bulgária', flag: '🇧🇬', ddi: '+359' },
  { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫', ddi: '+226' },
  { code: 'BI', name: 'Burundi', flag: '🇧🇮', ddi: '+257' },
  { code: 'BT', name: 'Butão', flag: '🇧🇹', ddi: '+975' },
  { code: 'CV', name: 'Cabo Verde', flag: '🇨🇻', ddi: '+238' },
  { code: 'CM', name: 'Camarões', flag: '🇨🇲', ddi: '+237' },
  { code: 'KH', name: 'Camboja', flag: '🇰🇭', ddi: '+855' },
  { code: 'CA', name: 'Canadá', flag: '🇨🇦', ddi: '+1' },
  { code: 'QA', name: 'Catar', flag: '🇶🇦', ddi: '+974' },
  { code: 'KZ', name: 'Cazaquistão', flag: '🇰🇿', ddi: '+7' },
  { code: 'TD', name: 'Chade', flag: '🇹🇩', ddi: '+235' },
  { code: 'CL', name: 'Chile', flag: '🇨🇱', ddi: '+56' },
  { code: 'CN', name: 'China', flag: '🇨🇳', ddi: '+86' },
  { code: 'CY', name: 'Chipre', flag: '🇨🇾', ddi: '+357' },
  { code: 'CO', name: 'Colômbia', flag: '🇨🇴', ddi: '+57' },
  { code: 'KM', name: 'Comores', flag: '🇰🇲', ddi: '+269' },
  { code: 'CG', name: 'Congo', flag: '🇨🇬', ddi: '+242' },
  { code: 'CD', name: 'Congo (RDC)', flag: '🇨🇩', ddi: '+243' },
  { code: 'KR', name: 'Coreia do Sul', flag: '🇰🇷', ddi: '+82' },
  { code: 'KP', name: 'Coreia do Norte', flag: '🇰🇵', ddi: '+850' },
  { code: 'CI', name: 'Costa do Marfim', flag: '🇨🇮', ddi: '+225' },
  { code: 'CR', name: 'Costa Rica', flag: '🇨🇷', ddi: '+506' },
  { code: 'HR', name: 'Croácia', flag: '🇭🇷', ddi: '+385' },
  { code: 'CU', name: 'Cuba', flag: '🇨🇺', ddi: '+53' },
  { code: 'DK', name: 'Dinamarca', flag: '🇩🇰', ddi: '+45' },
  { code: 'DJ', name: 'Djibuti', flag: '🇩🇯', ddi: '+253' },
  { code: 'DM', name: 'Dominica', flag: '🇩🇲', ddi: '+1767' },
  { code: 'EG', name: 'Egito', flag: '🇪🇬', ddi: '+20' },
  { code: 'SV', name: 'El Salvador', flag: '🇸🇻', ddi: '+503' },
  { code: 'AE', name: 'Emirados Árabes', flag: '🇦🇪', ddi: '+971' },
  { code: 'EC', name: 'Equador', flag: '🇪🇨', ddi: '+593' },
  { code: 'ER', name: 'Eritreia', flag: '🇪🇷', ddi: '+291' },
  { code: 'SK', name: 'Eslováquia', flag: '🇸🇰', ddi: '+421' },
  { code: 'SI', name: 'Eslovênia', flag: '🇸🇮', ddi: '+386' },
  { code: 'ES', name: 'Espanha', flag: '🇪🇸', ddi: '+34' },
  { code: 'US', name: 'Estados Unidos', flag: '🇺🇸', ddi: '+1' },
  { code: 'EE', name: 'Estônia', flag: '🇪🇪', ddi: '+372' },
  { code: 'SZ', name: 'Essuatíni', flag: '🇸🇿', ddi: '+268' },
  { code: 'ET', name: 'Etiópia', flag: '🇪🇹', ddi: '+251' },
  { code: 'FJ', name: 'Fiji', flag: '🇫🇯', ddi: '+679' },
  { code: 'PH', name: 'Filipinas', flag: '🇵🇭', ddi: '+63' },
  { code: 'FI', name: 'Finlândia', flag: '🇫🇮', ddi: '+358' },
  { code: 'FR', name: 'França', flag: '🇫🇷', ddi: '+33' },
  { code: 'GA', name: 'Gabão', flag: '🇬🇦', ddi: '+241' },
  { code: 'GM', name: 'Gâmbia', flag: '🇬🇲', ddi: '+220' },
  { code: 'GH', name: 'Gana', flag: '🇬🇭', ddi: '+233' },
  { code: 'GE', name: 'Geórgia', flag: '🇬🇪', ddi: '+995' },
  { code: 'GD', name: 'Granada', flag: '🇬🇩', ddi: '+1473' },
  { code: 'GR', name: 'Grécia', flag: '🇬🇷', ddi: '+30' },
  { code: 'GT', name: 'Guatemala', flag: '🇬🇹', ddi: '+502' },
  { code: 'GY', name: 'Guiana', flag: '🇬🇾', ddi: '+592' },
  { code: 'GN', name: 'Guiné', flag: '🇬🇳', ddi: '+224' },
  { code: 'GQ', name: 'Guiné Equatorial', flag: '🇬🇶', ddi: '+240' },
  { code: 'GW', name: 'Guiné-Bissau', flag: '🇬🇼', ddi: '+245' },
  { code: 'HT', name: 'Haiti', flag: '🇭🇹', ddi: '+509' },
  { code: 'HN', name: 'Honduras', flag: '🇭🇳', ddi: '+504' },
  { code: 'HU', name: 'Hungria', flag: '🇭🇺', ddi: '+36' },
  { code: 'YE', name: 'Iêmen', flag: '🇾🇪', ddi: '+967' },
  { code: 'IN', name: 'Índia', flag: '🇮🇳', ddi: '+91' },
  { code: 'ID', name: 'Indonésia', flag: '🇮🇩', ddi: '+62' },
  { code: 'IQ', name: 'Iraque', flag: '🇮🇶', ddi: '+964' },
  { code: 'IR', name: 'Irã', flag: '🇮🇷', ddi: '+98' },
  { code: 'IE', name: 'Irlanda', flag: '🇮🇪', ddi: '+353' },
  { code: 'IS', name: 'Islândia', flag: '🇮🇸', ddi: '+354' },
  { code: 'IL', name: 'Israel', flag: '🇮🇱', ddi: '+972' },
  { code: 'IT', name: 'Itália', flag: '🇮🇹', ddi: '+39' },
  { code: 'JM', name: 'Jamaica', flag: '🇯🇲', ddi: '+1876' },
  { code: 'JP', name: 'Japão', flag: '🇯🇵', ddi: '+81' },
  { code: 'JO', name: 'Jordânia', flag: '🇯🇴', ddi: '+962' },
  { code: 'KI', name: 'Kiribati', flag: '🇰🇮', ddi: '+686' },
  { code: 'KW', name: 'Kuwait', flag: '🇰🇼', ddi: '+965' },
  { code: 'LA', name: 'Laos', flag: '🇱🇦', ddi: '+856' },
  { code: 'LS', name: 'Lesoto', flag: '🇱🇸', ddi: '+266' },
  { code: 'LV', name: 'Letônia', flag: '🇱🇻', ddi: '+371' },
  { code: 'LB', name: 'Líbano', flag: '🇱🇧', ddi: '+961' },
  { code: 'LR', name: 'Libéria', flag: '🇱🇷', ddi: '+231' },
  { code: 'LY', name: 'Líbia', flag: '🇱🇾', ddi: '+218' },
  { code: 'LI', name: 'Liechtenstein', flag: '🇱🇮', ddi: '+423' },
  { code: 'LT', name: 'Lituânia', flag: '🇱🇹', ddi: '+370' },
  { code: 'LU', name: 'Luxemburgo', flag: '🇱🇺', ddi: '+352' },
  { code: 'MK', name: 'Macedônia do Norte', flag: '🇲🇰', ddi: '+389' },
  { code: 'MG', name: 'Madagascar', flag: '🇲🇬', ddi: '+261' },
  { code: 'MY', name: 'Malásia', flag: '🇲🇾', ddi: '+60' },
  { code: 'MW', name: 'Malawi', flag: '🇲🇼', ddi: '+265' },
  { code: 'MV', name: 'Maldivas', flag: '🇲🇻', ddi: '+960' },
  { code: 'ML', name: 'Mali', flag: '🇲🇱', ddi: '+223' },
  { code: 'MT', name: 'Malta', flag: '🇲🇹', ddi: '+356' },
  { code: 'MA', name: 'Marrocos', flag: '🇲🇦', ddi: '+212' },
  { code: 'MU', name: 'Maurícia', flag: '🇲🇺', ddi: '+230' },
  { code: 'MR', name: 'Mauritânia', flag: '🇲🇷', ddi: '+222' },
  { code: 'MX', name: 'México', flag: '🇲🇽', ddi: '+52' },
  { code: 'MM', name: 'Mianmar', flag: '🇲🇲', ddi: '+95' },
  { code: 'FM', name: 'Micronésia', flag: '🇫🇲', ddi: '+691' },
  { code: 'MZ', name: 'Moçambique', flag: '🇲🇿', ddi: '+258' },
  { code: 'MD', name: 'Moldávia', flag: '🇲🇩', ddi: '+373' },
  { code: 'MC', name: 'Mônaco', flag: '🇲🇨', ddi: '+377' },
  { code: 'MN', name: 'Mongólia', flag: '🇲🇳', ddi: '+976' },
  { code: 'ME', name: 'Montenegro', flag: '🇲🇪', ddi: '+382' },
  { code: 'NA', name: 'Namíbia', flag: '🇳🇦', ddi: '+264' },
  { code: 'NR', name: 'Nauru', flag: '🇳🇷', ddi: '+674' },
  { code: 'NP', name: 'Nepal', flag: '🇳🇵', ddi: '+977' },
  { code: 'NI', name: 'Nicarágua', flag: '🇳🇮', ddi: '+505' },
  { code: 'NE', name: 'Níger', flag: '🇳🇪', ddi: '+227' },
  { code: 'NG', name: 'Nigéria', flag: '🇳🇬', ddi: '+234' },
  { code: 'NO', name: 'Noruega', flag: '🇳🇴', ddi: '+47' },
  { code: 'NZ', name: 'Nova Zelândia', flag: '🇳🇿', ddi: '+64' },
  { code: 'OM', name: 'Omã', flag: '🇴🇲', ddi: '+968' },
  { code: 'NL', name: 'Países Baixos', flag: '🇳🇱', ddi: '+31' },
  { code: 'PW', name: 'Palau', flag: '🇵🇼', ddi: '+680' },
  { code: 'PA', name: 'Panamá', flag: '🇵🇦', ddi: '+507' },
  { code: 'PG', name: 'Papua-Nova Guiné', flag: '🇵🇬', ddi: '+675' },
  { code: 'PK', name: 'Paquistão', flag: '🇵🇰', ddi: '+92' },
  { code: 'PY', name: 'Paraguai', flag: '🇵🇾', ddi: '+595' },
  { code: 'PE', name: 'Peru', flag: '🇵🇪', ddi: '+51' },
  { code: 'PL', name: 'Polônia', flag: '🇵🇱', ddi: '+48' },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹', ddi: '+351' },
  { code: 'KE', name: 'Quênia', flag: '🇰🇪', ddi: '+254' },
  { code: 'KG', name: 'Quirguistão', flag: '🇰🇬', ddi: '+996' },
  { code: 'GB', name: 'Reino Unido', flag: '🇬🇧', ddi: '+44' },
  { code: 'CF', name: 'Rep. Centro-Africana', flag: '🇨🇫', ddi: '+236' },
  { code: 'DO', name: 'Rep. Dominicana', flag: '🇩🇴', ddi: '+1809' },
  { code: 'CZ', name: 'Rep. Tcheca', flag: '🇨🇿', ddi: '+420' },
  { code: 'RO', name: 'Romênia', flag: '🇷🇴', ddi: '+40' },
  { code: 'RW', name: 'Ruanda', flag: '🇷🇼', ddi: '+250' },
  { code: 'RU', name: 'Rússia', flag: '🇷🇺', ddi: '+7' },
  { code: 'WS', name: 'Samoa', flag: '🇼🇸', ddi: '+685' },
  { code: 'SM', name: 'San Marino', flag: '🇸🇲', ddi: '+378' },
  { code: 'LC', name: 'Santa Lúcia', flag: '🇱🇨', ddi: '+1758' },
  { code: 'KN', name: 'São Cristóvão e Névis', flag: '🇰🇳', ddi: '+1869' },
  { code: 'ST', name: 'São Tomé e Príncipe', flag: '🇸🇹', ddi: '+239' },
  { code: 'VC', name: 'São Vicente e Granadinas', flag: '🇻🇨', ddi: '+1784' },
  { code: 'SC', name: 'Seicheles', flag: '🇸🇨', ddi: '+248' },
  { code: 'SN', name: 'Senegal', flag: '🇸🇳', ddi: '+221' },
  { code: 'SL', name: 'Serra Leoa', flag: '🇸🇱', ddi: '+232' },
  { code: 'RS', name: 'Sérvia', flag: '🇷🇸', ddi: '+381' },
  { code: 'SG', name: 'Singapura', flag: '🇸🇬', ddi: '+65' },
  { code: 'SY', name: 'Síria', flag: '🇸🇾', ddi: '+963' },
  { code: 'SO', name: 'Somália', flag: '🇸🇴', ddi: '+252' },
  { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰', ddi: '+94' },
  { code: 'SD', name: 'Sudão', flag: '🇸🇩', ddi: '+249' },
  { code: 'SS', name: 'Sudão do Sul', flag: '🇸🇸', ddi: '+211' },
  { code: 'SE', name: 'Suécia', flag: '🇸🇪', ddi: '+46' },
  { code: 'CH', name: 'Suíça', flag: '🇨🇭', ddi: '+41' },
  { code: 'SR', name: 'Suriname', flag: '🇸🇷', ddi: '+597' },
  { code: 'TJ', name: 'Tajiquistão', flag: '🇹🇯', ddi: '+992' },
  { code: 'TH', name: 'Tailândia', flag: '🇹🇭', ddi: '+66' },
  { code: 'TZ', name: 'Tanzânia', flag: '🇹🇿', ddi: '+255' },
  { code: 'TL', name: 'Timor-Leste', flag: '🇹🇱', ddi: '+670' },
  { code: 'TG', name: 'Togo', flag: '🇹🇬', ddi: '+228' },
  { code: 'TO', name: 'Tonga', flag: '🇹🇴', ddi: '+676' },
  { code: 'TT', name: 'Trinidad e Tobago', flag: '🇹🇹', ddi: '+1868' },
  { code: 'TN', name: 'Tunísia', flag: '🇹🇳', ddi: '+216' },
  { code: 'TM', name: 'Turcomenistão', flag: '🇹🇲', ddi: '+993' },
  { code: 'TR', name: 'Turquia', flag: '🇹🇷', ddi: '+90' },
  { code: 'TV', name: 'Tuvalu', flag: '🇹🇻', ddi: '+688' },
  { code: 'UA', name: 'Ucrânia', flag: '🇺🇦', ddi: '+380' },
  { code: 'UG', name: 'Uganda', flag: '🇺🇬', ddi: '+256' },
  { code: 'UY', name: 'Uruguai', flag: '🇺🇾', ddi: '+598' },
  { code: 'UZ', name: 'Uzbequistão', flag: '🇺🇿', ddi: '+998' },
  { code: 'VU', name: 'Vanuatu', flag: '🇻🇺', ddi: '+678' },
  { code: 'VA', name: 'Vaticano', flag: '🇻🇦', ddi: '+379' },
  { code: 'VE', name: 'Venezuela', flag: '🇻🇪', ddi: '+58' },
  { code: 'VN', name: 'Vietnã', flag: '🇻🇳', ddi: '+84' },
  { code: 'ZM', name: 'Zâmbia', flag: '🇿🇲', ddi: '+260' },
  { code: 'ZW', name: 'Zimbábue', flag: '🇿🇼', ddi: '+263' },
];
